module.exports = __webpack_public_path__ + "img/food2.8755afd3.png";